export default __webpack_public_path__ + "static/media/sano-de-raiz.e0c92ef9.svg";